module.exports = __webpack_public_path__ + "img/equipment_home@1x.f0cef703.png";